import * as React from "react";
import {} from "@blueprintjs/core";
import { useCommonHooks } from "../../hooks";
import { useGradeStatusRef } from "../../hooks/applicationHooks/useGradeStatusRef";
import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";

import { ReferentialItemDto } from "../../api";
import { nameof } from "../../utils";

export interface CadreStatusSelectProps
  extends Pick<
    IFGSelectInputProps<any>,
    "requiredMark" | "visible" | "disabled" | "style" | "readonly"
  > {
  name: string;
  label?: string;
  loading?: boolean;
}

export const GradeStatusSelect: React.FunctionComponent<
  CadreStatusSelectProps
> = ({ name, label, loading = false, ...fgSelectInputProps }) => {
  const { t } = useCommonHooks();
  const { cadreStatuses, cadreStatusesLoading } = useGradeStatusRef();

  return (
    <FGSelectInput
      label={label || t("CadreStatus")}
      name={name}
      items={cadreStatuses}
      loading={cadreStatusesLoading || loading}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};

export default GradeStatusSelect;
